import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-base text-main font-sans selection:bg-warm/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <ValueStack data-id="element-6" />
        <GuaranteeSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}